import type { Notification } from '../services/notificationApi';
import { parseNotificationMetadata } from './contractRequestNotification';
import { openWebManagement } from './webAppBridge';

export const SUBSCRIPTION_RENEWAL_PATH = '/account-management';
export const SUBSCRIPTION_RENEWAL_ACTION = 'renew_subscription';

export function isSubscriptionRenewalMetadata(metadata: Record<string, unknown> | null | undefined): boolean {
  if (!metadata) return false;
  const action = String(metadata.action || '').trim();
  const actionUrl = String(metadata.action_url || metadata.actionUrl || '').trim();
  return action === SUBSCRIPTION_RENEWAL_ACTION || actionUrl === SUBSCRIPTION_RENEWAL_PATH;
}

export function isSubscriptionRenewalNotification(
  notification: Pick<Notification, 'metadata' | 'content' | 'notification_type'> | {
    metadata?: unknown;
    content?: unknown;
    notification_type?: string;
  },
): boolean {
  if (String(notification.notification_type || '') === 'subscription') {
    const metadata = parseNotificationMetadata(notification);
    if (isSubscriptionRenewalMetadata(metadata)) return true;
  }
  return isSubscriptionRenewalMetadata(parseNotificationMetadata(notification));
}

export function isSubscriptionRenewalPushData(data: Record<string, unknown> | null | undefined): boolean {
  if (!data) return false;
  return isSubscriptionRenewalMetadata(data);
}

/** Mở trang quản lý gói chủ nhà trên web để thanh toán/gia hạn. */
export function openLandlordPackageManagement(): void {
  openWebManagement(SUBSCRIPTION_RENEWAL_PATH);
}
